import { Injectable } from '@angular/core';

import {
  NzNotificationService,
  NzNotificationDataOptions,
} from 'ng-zorro-antd/notification';

import { hasIn } from 'lodash';
import { OxErrorResponse } from '..';
import { TranslateService } from '@ngx-translate/core';
import { Unsubscribe } from '../classes';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends Unsubscribe {
  errTitle: string;
  errMsg: string;

  constructor(
    private translateService: TranslateService,
    private notification: NzNotificationService
  ) {
    super();

    this.translateService
      .stream('MESSAGE.ERROR')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((errTitle) => {
        this.errTitle = errTitle;
      });

    this.translateService
      .stream('MESSAGE.GENERIC_ERROR_MSG')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((errMsg) => {
        this.errMsg = errMsg;
      });
  }

  success(
    title: string,
    message: string,
    messageValue?: string,
    titleValue?: string,
    notificationOptions?: NzNotificationDataOptions
  ) {
    this.translateService
      .stream([messageValue, titleValue])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((values) => {
        messageValue = values[messageValue];
        titleValue = values[titleValue];
        this.translateService
          .stream(title, { value: titleValue })
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((translatedTitle) => {
            this.translateService
              .get(message, { value: messageValue })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((translatedMessage) => {
                this.notification.create(
                  'success',
                  translatedTitle,
                  translatedMessage,
                  notificationOptions
                );
              });
          });
      });
  }

  error(
    title: string,
    message: string,
    messageValue?: string,
    titleValue?: string,
    notificationOptions?: NzNotificationDataOptions
  ) {
    this.translateService
      .stream(title, { value: titleValue })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((translatedTitle) => {
        this.translateService
          .stream(message, { value: messageValue })
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((translatedMessage) => {
            this.notification.create(
              'error',
              translatedTitle,
              translatedMessage,
              notificationOptions
            );
          });
      });
  }

  errorHandler(error: OxErrorResponse) {
    if (hasIn(error, 'details') && hasIn(error, 'error')) {
      Object.keys(error.details).forEach((key: string) => {
        this.notification.create(
          'error',
          error.error,
          `(${key}) ${error.details[key]}`
        );
      });
    } else if (hasIn(error, 'error')) {
      this.notification.create('error', this.errTitle, error.error);
    } else {
      this.notification.create('error', this.errTitle, this.errMsg);
    }
  }

  remove(id?) {
    this.notification.remove(id);
  }
}
